// src/config/notification.config.js
export const notificationConfig = {
    // Perfil padrão a ser usado quando nenhum for especificado
    defaultWhatsappProfile: 'notificacoes',
    
    // Definição dos perfis de WhatsApp
    whatsappProfiles: {
      // Perfil para mensagens transacionais
      notificacoes: {
        provider: 'zapi',              // API a ser usada
        senderNumber: '5511999999999', // Número de origem (opcional, pode ser definido pela API)
        description: 'Mensagens sobre pagamentos e planos',
        config: {
          apiBaseUrl: 'https://api.z-api.io/instances',
          instance: '3DEE9B6151C3801B303A32C54B267657',
          instanceToken: '629B05BBB90A256094971947',
          clientToken: 'Fb69984f4e842433f89ce9f75a94b49aaS'
        }
      },
      transacionais: {
        provider: 'zapi',              // API a ser usada
        senderNumber: '5511999999999', // Número de origem (opcional, pode ser definido pela API)
        description: 'Mensagens sobre pagamentos e planos',
        config: {
          apiBaseUrl: 'https://api.z-api.io/instances',
          instance: '3DEE9B6151C3801B303A32C54B267657',
          instanceToken: '629B05BBB90A256094971947',
          clientToken: 'Fb69984f4e842433f89ce9f75a94b49aaS'
        }
      },
      
      // Perfil para notificações gerais
      alternativo: {
        provider: 'chat360',
        senderNumber: '5511888888888',
        description: 'Notificações sobre avaliações e relatórios',
        config: {
          apiBaseUrl: 'https://api.chat360.pro/v2/api/external',
          instance: '9b9d5778-3cbc-4686-a87d-1301f76cac63',
          apiToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6MSwicHJvZmlsZSI6ImFkbWluIiwic2Vzc2lvbklkIjo2LCJpYXQiOjE3NDE0MTY0MTgsImV4cCI6MTgwNDQ4ODQxOH0.s4-OcxEfqDp3i56Mx_reanWNeZ99_axU4MwoHwAoKYE'
        }
      }
    }
  };